import script from "./ProfileAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileAccount.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileAccount.vue?vue&type=style&index=0&id=43448312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43448312"]])

export default __exports__